import type { PropsWithChildren } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import _BaseLabel from './_BaseLabel'

const InformationLabelElement = styled(_BaseLabel)`
  background-color: var(--palette-neutral-surface-light-background);
  border-color: var(--palette-neutral-surface-light-foreground);
  color: var(--palette-highlight-primary-dark-foreground);
`

interface Props {
  className?: string
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  ref?: React.Ref<HTMLSpanElement>
  format?: React.ComponentProps<typeof _BaseLabel>['format']
}

/**
 * Documentation: <https://aussiecommerce.atlassian.net/wiki/spaces/UXUI/pages/4504289338/Label>
 */
function InformationLabel({ className, ...labelProps }: PropsWithChildren<Props>) {
  return <InformationLabelElement
    className={clsx(
      className,
    )}
    {...labelProps}
  />
}

export default InformationLabel
